import * as Yup from 'yup';

const templateValidationSchema = Yup.object().shape({
  Name: Yup.string()
    .required('Emri i template-it është i detyrueshëm')
    .min(3, 'Emri duhet të ketë të paktën 3 karaktere')
    .max(200, 'Emri nuk duhet të kalojë 200 karaktere'),
  Content: Yup.string()
    .required('Përmbajtja e template-it është e detyrueshme')
    .min(10, 'Template-i duhet të ketë të paktën 10 karaktere'),
});

export default templateValidationSchema;